import { Skeleton } from '@components/ui/skeleton'
import { useContractorContext } from '@features/Contractor/ContractorContext'
import { AddEmployee } from '@features/Contractor/Employee/Add'
import { EmployeeContextProvider } from '@features/Contractor/Employee/EmployeeContext'
import { getCoursesQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const AddEmployeeRouteSkeleton: React.FC = () => (
  <div className="space-y-6">
    <Skeleton className="h-10 w-64" />
    <Skeleton className="h-125 w-full" />
  </div>
)

const AddEmployeeRoute: React.FC = () => {
  const { contractorId } = Route.useParams()
  const { data: contractor, isLoading: isLoadingContractor } = useContractorContext()

  const coursesQuery = useQuery({
    ...getCoursesQuery(contractorId, contractor?.tenantId),
    enabled: !!contractor?.tenantId,
  })

  if (isLoadingContractor || !contractor) return <AddEmployeeRouteSkeleton />

  return (
    <EmployeeContextProvider
      value={{
        courses: coursesQuery.data?.items,
        isLoading: coursesQuery.isLoading,
        isError: coursesQuery.isError,
        refetch: () => void coursesQuery.refetch(),
      }}
    >
      <AddEmployee contractorId={contractorId} tenantId={contractor.tenantId} />
    </EmployeeContextProvider>
  )
}

export const Route = createFileRoute('/contractor/$contractorId/employees/add')({
  component: AddEmployeeRoute,
  staticData: {
    breadcrumb: t('contractor.addEmployee.title'),
  },
})
